// File Metadata:
// Filename: useTitle.js
// Version: 1.00
// Created: 2022-09-28 21:37:20
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { useEffect } from 'react'

const useTitle = title => {
	useEffect(() => {
		const prevTitle = document.title
		document.title = title
		return () => (document.title = prevTitle)
	}, [title])
}

export default useTitle
